var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"nonzero","stroke":"#00ff89","strokeWidth":"3.402","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"10","strokeDasharray":"","strokeDashoffset":"0","fontFamily":"none","fontWeight":"none","fontSize":"none","textAnchor":"none","style":{"mixBlendMode":"normal"}},React.createElement("g",{"transform":"translate(-4.1922,0) scale(6.97016,6.97016)"},React.createElement("path",{"transform":"translate(-284.497,-188.907)","d":"M304.064,224.432l-17.164,-17.161l17.161,-17.161","id":"Path_2"}))));
}

ArrowInline.defaultProps = {"version":"1.1","width":"20.769","height":"36.728","viewBox":"0,0,144.75,256"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
